<template>
  <div class="mx-auto mb-2">
    <!-- <carsouel-view /> And  menu  -->
    <HomeLayout :data="true" :isLoading="isLoading">
      <div>
        <swiper-slider :slidersData="slidersData" :isLoading="isLoading" />
      </div>
    </HomeLayout>
    <section v-if="isLoading">
      <div class="my-6" v-for="index in 3" :key="index">
        <div class="flex md:my-6 my-4 mr-8 md:mr-[51px]" dir="rtl">
          <HeaderTitle />
        </div>
        <div
          class="flex flex-nowarp md:gap-4 gap-0 overflow-hidden mr-4 md:mr-[51px] my-3"
          dir="rtl"
        >
          <loader-view
            v-for="index in 6"
            :key="index"
            class="flex-none w-[calc(100%/3)] md:w-[calc(100%/6)] h-48"
          />
        </div>
      </div>
    </section>
    <section v-else>
      <div v-for="collection in filteredCollections" :key="collection.id">
        <!-- default layout for neel -->
        <div class="my-6" v-if="collection.layout === 'neel'">
          <div class="flex md:my-6 my-4 mr-8 md:mr-[51px]" dir="rtl">
            <SeriesHeader :title="`${collection.name}`" class="md:mr-0 -mr-4" />
          </div>
          <div
            class="mx-auto mr-4 md:mr-[51px] my-3"
            dir="rtl"
            v-if="collection.type === 'Serie'"
          >
            <DefaultSwiper :items="collection.series" />
          </div>
          <div
            class="mx-auto mr-4 md:mr-[51px] my-3"
            dir="rtl"
            v-if="collection.type === 'Eposide'"
          >
            <home-eps :items="collection.eposides" :image="collection.image" />
          </div>
        </div>
        <!-- soba layout  -->
        <!-- soba layout -->
        <div
          v-else-if="collection.layout === 'soba'"
          class=" md:mx-[51px] mb-3 overflow-hidden  bg-no-repeat bg-cover bg-center pt-36 pb-6 md:pt-40 md:pb-10"
          :style="{
            backgroundImage: `url(${getBackgroundImage(
              collection.background
            )})`,
          }"
        >
       
          <!-- SeriesCard at the bottom -->
          <div dir="rtl">
            <SeriesCard :items="collection.series" />
          </div>
        </div>
        <!-- tuti layout -->
        <div class="my-4" v-else-if="collection.layout === 'tuti'">
          <div class="flex md:my-6 my-4 mr-8 md:mr-[51px]" dir="rtl">
            <SeriesHeader :title="collection.name" class="md:mr-0 -mr-4" />
          </div>

          <div class="mx-auto mr-4 md:mr-[51px] my-3" dir="rtl">
            <TutiSwiper :items="collection.series" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// store data
import { mapState, mapActions } from "pinia";

import { useSerieStore } from "@/stores/serie";

import HomeLayout from "@/components/HomeLayout.vue";
import SeriesCard from "@/components/cards/SeriesCard.vue";
import SeriesHeader from "@/components/home/SeriesHeader.vue";
import { usehomeStore } from "@/stores/home";
import { useSlidersStore } from "@/stores/sliders";

import DefaultSwiper from "@/components/cards/DefaultSwiper.vue";
import TutiSwiper from "@/components/cards/TutiSwiper.vue";
import { S3_BASE_URL } from "@/constants";
import SwiperSlider from "@/components/carousel/SwiperSlider.vue";
import HeaderTitle from "@/components/cards/loaders/HeaderTitle.vue";
import LoaderView from "@/components/cards/loaders/LoaderView.vue";
import HomeEps from "@/components/cards/HomeEps.vue";
export default {
  // data section
  data() {
    return {
      isLoading: false,
      title: "",
      page: 1,
      MostWatchedData: false,
      base_url: S3_BASE_URL,
    };
  },
  /**
   * home required components
   *
   */
  components: {
    HomeLayout,
    SeriesCard,
    SeriesHeader,
    DefaultSwiper,
    TutiSwiper,
    SwiperSlider,
    HeaderTitle,
    LoaderView,
    HomeEps,
  },

  computed: {
    ...mapState(useSerieStore, ["seriesData", "getMostWatched"]),
    ...mapState(usehomeStore, ["getCollections"]),
    ...mapState(useSlidersStore, ["slidersData"]),
    // exexlude  Short and Video form getCollections
    filteredCollections() {
      return this.getCollections.filter(
        (collection) =>
          collection.type !== "Short" && collection.type !== "Video"
      );
    },
  },

  methods: {
    ...mapActions(useSerieStore, ["showHomeSeries", "showMostWatched"]),
    ...mapActions(usehomeStore, ["fetchCollections"]),
    ...mapActions(useSlidersStore, ["showSlidersData"]),

    getBackgroundImage(image) {
      return `${this.base_url}collections/${image}`;
    },
    getDescriptionImage(image) {
      return `${this.base_url}collections/${image}`;
    },
  },

  async mounted() {
    if (this.getCollections.length > 0) return;
    try {
      this.isLoading = true;

      await Promise.all([
        this.showHomeSeries(1, 10),
        this.fetchCollections(),
        this.showSlidersData(),

        setTimeout(() => {
          this.isLoading = false;
        }, 1000),
      ]);
    } catch (error) {
      // this.isLoading = false;
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      console.error("Failed to get portal data", error);
    }
  },
};
</script>
<style scoped>
.shadow {
  box-shadow: 35px -4px 19px 6px rgba(0, 0, 0, 0.56) inset;
  -webkit-box-shadow: 35px -4px 19px 6px rgba(0, 0, 0, 0.56) inset;
  -moz-box-shadow: 35px -4px 19px 6px rgba(0, 0, 0, 0.56) inset;
}

.border-cover {
  border-color: #191a2c;
}
</style>
